import { CourseStatus, formatMinutes, LessonListItem } from '@atlassian/learning-components';

import { ContentfulSmCourse } from 'src/graphql/queries/GetSmCourse';
import { shortenDurationString } from 'src/pages/LearningPathPage/utils';

export const FIELD_ID = 'lessonId';

export const getDuration = (course: ContentfulSmCourse): number =>
  course.lessonsCollection.items.reduce((acc, lesson) => acc + (lesson.duration || 0), 0);

export const getLessonData = (
  lesson: ContentfulSmCourse['lessonsCollection']['items'][0],
  getLessonStatus: (lessonId: string) => CourseStatus,
  handleHrefLink: (lesson: ContentfulSmCourse['lessonsCollection']['items'][0]) => string,
): FormattedLessonData => ({
  id: lesson.sys.id,
  title: lesson.title,
  slug: lesson.slug,
  duration: lesson.duration || 0,
  status: getLessonStatus(lesson.sys.id),
  href: handleHrefLink(lesson),
});

export interface FormattedLessonData {
  id: string;
  title: string;
  slug: string;
  duration: number;
  status: CourseStatus;
  href: string;
}

export const getLessonsData = (
  course: ContentfulSmCourse,
  getLessonCompletionStatus: (lessonId: string) => boolean,
): LessonListItem[] =>
  course.lessonsCollection.items.map((lesson) => ({
    title: lesson.title,
    slug: lesson.slug,
    duration: shortenDurationString(formatMinutes(lesson.duration)),
    isCompleted: getLessonCompletionStatus(lesson.sys.id),
  }));
